module.exports = __webpack_public_path__ + "media/images/tip-box-top-60a00031.gif";